import { get as getCookie, set as setCookie } from 'js/lib/cookie';

// A cookie rather than web storage so the server render of checkout can exclude guest checkout visitors too.
export const GUEST_CHECKOUT_EXPOSED_COOKIE = 'guest_checkout_exposed';

// Outlasts both overlapping checkout experiments so an exposed browser stays excluded until they read out.
const GUEST_CHECKOUT_EXPOSED_COOKIE_DAYS = 90;

export function markGuestCheckoutExposed(): void {
  if (typeof window === 'undefined') {
    return;
  }
  setCookie(GUEST_CHECKOUT_EXPOSED_COOKIE, '1', { days: GUEST_CHECKOUT_EXPOSED_COOKIE_DAYS, sameSite: 'Lax' });
}

export function hasGuestCheckoutExposure(): boolean {
  return getCookie(GUEST_CHECKOUT_EXPOSED_COOKIE) === '1';
}
